import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AppServiceService } from '../service/app-service.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-guidelines',
  templateUrl: './guidelines.component.html',
  styleUrls: ['./guidelines.component.css']
})
export class GuidelinesComponent implements OnInit {

  constructor(private appService: AppServiceService, private router: Router) { }

  ngOnInit(): void {
	this.appService.setTitle('Publishing Guidelines');
	
	this.router.events.subscribe ((evt) => {
		if (!(evt instanceof NavigationEnd)) {
			return;
		}
		window.scrollTo(0,0)
	});

  }

}
